import {HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {FuseTranslationLoaderService} from '@fuse/services/translation-loader.service';
import {ApiErrorModel} from '@models/@base/api-error.model';
import {GeneralCodeMessageModel} from '@models/@base/general-code-message.model';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from '@services/local-storage.service';
import {NotificationsService} from 'angular2-notifications';
import {locale as czech} from 'app/i18n/cs';
import {locale as english} from 'app/i18n/en';
import {ErrorDialogComponent} from 'app/main/@error-dialog/error-dialog.component';
import Utils from 'app/utils/utils';
import {environment} from 'environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private notificationsService: NotificationsService,
        private fuseTranslationLoaderService: FuseTranslationLoaderService,
        private translateService: TranslateService,
        private matDialog: MatDialog,
        private localStorageService: LocalStorageService,
    ) {
        this.fuseTranslationLoaderService.loadTranslations(czech, english);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                // show in console
                if (!environment.production) {
                    console.log(error);
                }

                // process bad request
                if (error.status === 400 && error.error) {
                    const apiError: ApiErrorModel = error.error;
                    if (apiError.value) {
                        // InnerError shoudl be handled in specific Api
                        if (apiError.value.code !== 'InnerError') {
                            this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), this.translateService.instant(`ERROR_CODE.${apiError.value.code.toUpperCase()}`));
                        }

                        if (apiError.value.answersGuardResult) {
                            const errDialog = this.matDialog.open(ErrorDialogComponent, {
                                data: {
                                    header: 'Nalezené chyby v ID dotazníku',
                                    messages: apiError.value.answersGuardResult.failures.map(r => r.message)
                                },
                                disableClose: true
                            });
                            errDialog.afterClosed().subscribe((r) => {
                                if (r) {
                                    this.router.navigate([r]).then(() => {
                                    });
                                }
                                this.localStorageService.saveGuardRedirectUrl(null);
                            });
                        }
                    } else if (apiError.errors) {
                        const errKeys = Object.keys(apiError.errors);
                        errKeys.forEach(errKey => {
                            this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `${errKey}: ${apiError.errors[errKey]}`);
                        });
                    } else {
                        if (Utils.isJsonString(apiError)) {
                            this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `Chyba v těchto atributech: ${Object.keys(apiError).join(', ')}`);
                        } else {
                            this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `Chyba v těchto atributech: ${JSON.stringify(error.error)}`);
                        }
                    }
                } else if (error.status === 422 && error.error && error.error.guard) {
                    const guards: GeneralCodeMessageModel[] = error.error.guard.failures;
                    for (const guard of guards) {
                        this.notificationsService.warn('Chyba validace', this.translateService.instant(`GUARD.${guard.code}`));
                    }
                } else {
                    // ignore not found
                    if (error.status !== 404) {
                        this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`));
                    }
                }
                return throwError(error);
            })
        );

    }

}

export const ErrorInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
};
